var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPmrYellowBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gu\\xEDa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconos",
    transform: "translate(-78.000000, -584.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMR_alerta",
    transform: "translate(78.000000, 584.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMR-28"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ef9206",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 9.64285714,
    x2: 7.5,
    y2: 9.64285714,
    id: "Path-5",
    stroke: "#0E3FF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 7.5,
    cy: 10.1785714,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3.21428571 C7.77473349,3.21428571 8.00116455,3.47279477 8.03211014,3.80583407 L8.03571429,3.88392857 L8.03571429,7.90178571 C8.03571429,8.27161925 7.79586683,8.57142857 7.5,8.57142857 C7.22526651,8.57142857 6.99883545,8.31291952 6.96788986,7.97988022 L6.96428571,7.90178571 L6.96428571,3.88392857 C6.96428571,3.51409503 7.20413317,3.21428571 7.5,3.21428571 Z",
    id: "Path-5",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmrYellowBig);
export default __webpack_public_path__ + "static/media/pmr-yellow-big.5acb7927.svg";
export { ForwardRef as ReactComponent };